import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>デザインシステム発注ガイド</>,
  alt: 'デザインシステム発注ガイド',
  readText: (
    <>
      デザインマネージャーも安心！スケールするプロダクトのための実装から運用まで見据えた、デザインシステムの発注の際に使えるガイドライン
    </>
  ),
  imgLarge: '/images/img/download/design-system/thumbnail_ds.webp',
  imgCapture: '/images/img/download/design-system/capture_ds.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      デザインシステムの導入を検討中の方や、内製化支援をご希望の方向けに、「5STEPでわかる発注フロー」をまとめた資料です。具体的な導入手順を段階的に解説しており、Aitriaやデザインシステムにご興味があるすべての方にご覧いただきたい内容となっています。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: 'なぜ「作って終わり」で終わるのか、失敗パターンと回避策',
  secondHalf2: 'デザイナー33%・エンジニア47%の工数削減エビデンス',
  secondHalf3: '調査から実装まで、迷わない構築5STEPガイドライン',
  secondHalf4: '外部に頼みながら、社内ノウハウとして蓄積する進め方',
}

const DownloadDesignSystem: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', 'de08f3e2-8a49-4a9f-b039-dd441f7663d9', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], {
      opacity: 0,
      y: 50,
    })

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    })

    const commonTo = { opacity: 1, y: 0 }

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1)
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents leftContentData={leftContentData} isSecondContent={true} />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadDesignSystem
